import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import Title, {} from '@helsenorge/designsystem-react/components/Title';
import fontStyles from '@helsenorge/designsystem-react/scss/typography.module.scss';
import PortableText from '../..';
import { PortableTextContext } from '../../portable-text-content';
const TextBlockComponent = ({ title, titleHtmlMarkup = 'h2', titleAppearance = 'title2', mainIntro, mainBody, }) => {
    const components = useContext(PortableTextContext)?.components;
    return (_jsxs("div", { children: [_jsx(Title, { htmlMarkup: titleHtmlMarkup, appearance: titleAppearance, children: title }), mainIntro && _jsx("p", { className: fontStyles.preamble, children: mainIntro }), _jsx(PortableText, { value: mainBody, components: components })] }));
};
const TextBlock = ({ value }) => (_jsx(TextBlockComponent, { title: value.title, titleHtmlMarkup: value.titleHtmlMarkup, titleAppearance: value.titleAppearance, mainIntro: value.mainIntro, mainBody: value.mainBody, removePadding: value.removePadding }));
export default TextBlock;
